module.exports = __webpack_public_path__ + "img/flat collar topline length.ff9f4e0d.png";